// DS1.7.9
import React from 'react';
import classnames from 'classnames';
import s from './DeviationFlag.scss';

interface Props {
  variant: 'daily-deviation' | 'hype' | 'stash';
  size: 'large' | 'medium' | 'small';
  className?: string;
}

const DeviationFlag: React.FC<Props> = ({ variant, size, className }) => (
  <div className={classnames(s['root'], s[variant], s[size], className)} />
);
DeviationFlag.displayName = 'DeviationFlag';

export default DeviationFlag;
